import { useTribalContext } from '@/context/tribal';
import facebookIcon from '@/assets/facebook.svg';
import instagramIcon from '@/assets/instagram.svg';
import tiktokIcon from '@/assets/tiktok.svg';
import { StyledSocialMediaLinks } from './SocialMediaLinks.styles';
import twitterIcon from '@/assets/twitter.svg';

const SocialMediaLinks = () => {
  const { contentManager } = useTribalContext();
  return (
    <StyledSocialMediaLinks>
      <li>
        <a href={contentManager.get('vw-facebook-url')} target="_blank">
          <img src={facebookIcon} />
        </a>
      </li>
      <li>
        <a href={contentManager.get('vw-twitter-url')} target="_blank">
          <img src={twitterIcon} />
        </a>
      </li>
      <li>
        <a href={contentManager.get('vw-instagram-url')} target="_blank">
          <img src={instagramIcon} />
        </a>
      </li>
      <li>
        <a href={contentManager.get('vw-tiktok-url')} target="_blank">
          <img src={tiktokIcon} />
        </a>
      </li>
    </StyledSocialMediaLinks>
  );
};

export default SocialMediaLinks;
